import React from 'react';
import PropTypes from 'prop-types';
import DateTimeField from 'react-bootstrap-datetimepicker';

class Form extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Form';
        //State
        this.state = {
			date : null,
			max_wind_speed : null,
			max_hail_size : null,
			house_count : null,
			hail_duration : null,
			states : [],
			cities : []
        }

        //Handlers
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleChange(event) {
        var state = Object.assign({},this.state,{});
        var item = state;
        var value = event.target.value;
        var keys = event.target.name;

        keys = keys.split('.');
        var iterations = keys.length - 1;
        for (var i = 0; i < iterations; i++) {
            item = item[keys.shift()];
        };
        switch(event.target.name) {
            default:
                item[keys[0]] = value;
                break;
        }
        this.setState(state);
    }
    handleSave(event) {
    	event.preventDefault();
    	if(this.props.onSave)
    		this.props.onSave(this.state);
    }
    handleCancel(event) {
    	event.preventDefault();
    	if(this.props.onCancel)
    		this.props.onCancel();
    }
    render() {
        return (
        	<div className="form form-bordered">
        		{/**/}
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">Title</div>
	        		<div className="col-xs-8">
		        		<input onChange={this.handleChange} type="text" className="form-control" name="title" value={this.state.title} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">Date</div>
	        		<div className="col-xs-8">
		        		{/*<input onChange={this.handleChange} type="text" className="form-control" name="date" value={this.state.date} />*/}
		        		<DateTimeField onChange={this.handleChange} dateTime={this.state.date} format={'MM/DD/YYYY'} inputFormat={'MM/DD/YYYY'} showToday={true} viewMode='days' defaultText={''} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">Max Wind Speed</div>
	        		<div className="col-xs-8">
		        		<input onChange={this.handleChange} type="text" className="form-control" name="max_wind_speed" value={this.state.max_wind_speed} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">Max Hail Size</div>
	        		<div className="col-xs-8">
		        		<input onChange={this.handleChange} type="text" className="form-control" name="max_hail_size" value={this.state.max_hail_size} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">House Count</div>
	        		<div className="col-xs-8">
		        		<input onChange={this.handleChange} type="text" className="form-control" name="house_count" value={this.state.house_count} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        		<div className="form-group">
	        		<div className="col-xs-4 control-label">Hail Duration</div>
	        		<div className="col-xs-8">
		        		<input onChange={this.handleChange} type="text" className="form-control" name="hail_duration" value={this.state.hail_duration} />
	        		</div>
	        	<div className="col-xs-12">{/*Error Message*/}</div>
        		</div>
        	</div>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/browser/components/storms/stormForm.js